import { createSelector } from '@ngrx/store';
import { selectRouteParams } from 'src/app/store/router';
import * as fromNoParkingZones from '../reducers/no-parking-zones.reducer';
import { NoParkingZone } from '../../../modules/no-parking-zones/interfaces';
import { AppState } from 'src/app/store/state';

export const selectNoParkingZonesState = (state: AppState) => state.noParkingZones;

export const selectNoParkingZonesEntities = createSelector(
    selectNoParkingZonesState,
    fromNoParkingZones.getNoParkingZonesEntities
);

export const selectAllNoParkingZones = createSelector(
    selectNoParkingZonesEntities,
    (entities: { [id: string]: NoParkingZone }) => {
        return Object.values(entities);
    }
);

export const selectNoParkingZone = createSelector(
    selectNoParkingZonesEntities,
    selectRouteParams,
    (entities: { [id: string]: NoParkingZone }, routeParams: any) => entities[routeParams.id]
);
